/**
 * 会员菜品常量
 */

/**
 * 会员菜品分类名称
 */
export const MEMBER_ITEM_CATEGORY_NAME = 'Member Reward'

/**
 * 会员菜品相关的本地化键名
 */
export enum MemberItemLocaleKeys {
  TIP = 'tip',
  MEMBER_ITEM_CATEGORY = 'memberItemCategory',
  ONLY_ONE_FOOD_ITEM = 'onlyOneFoodItem',
  MEMBER_ITEM_THRESHOLD_MESSAGE = 'memberItemThresholdMessage',
  MEMBER_ITEM_REMOVED = 'memberItemRemoved',
  PLEASE_LOGIN_TO_USE_MEMBER_ITEM = 'pleaseLoginToUseMemberItem',
  CANNOT_ADD_MORE_MEMBER_ITEM = 'cannotAddMoreMemberItem',
  MEMBER_ITEM_USED_TODAY = 'memberItemUsedToday',
  LEVEL_NOT_ENOUGH = 'levelNotEnough',
  REMOVE_AND_CONTINUE = 'removeAndContinue', //
  ADD_MORE = 'addMore'
}
